module.exports = __webpack_public_path__ + "static/media/2022_IMG_9066.8b9e3944.jpg";